import { createReducer } from 'redux-act';
import * as actions from '#app/actions/obligationPayment';

interface ObligationPaymentState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: ObligationPaymentState = {
  modalVisible: false,
  form: {},
};

const setObligationPaymentModalVisible = (
  state: ObligationPaymentState,
  bool: boolean
): ObligationPaymentState => ({
  ...state,
  modalVisible: bool,
});

const setObligationPaymentForm = (
  state: ObligationPaymentState,
  form: Record<string, unknown>
): ObligationPaymentState => ({
  ...state,
  form: form,
  modalVisible: true,
});

export default createReducer<ObligationPaymentState>(
  {
    [actions.setObligationPaymentModalVisible as any]: setObligationPaymentModalVisible,
    [actions.setObligationPaymentForm as any]: setObligationPaymentForm,
  },
  initialState
);
